import { useSelector } from "react-redux";
import { RootState } from "store";
import { Auth } from "@spike/auth-model";

export const useAuth = (): Auth => {
	const auth = useSelector<RootState, Auth>(state => state.login.auth);
  return auth;
};

export const getUserInitials = (auth: Auth): string => {
	if (!auth?.user) return '';
	
	const firstName = auth.user.firstName || '';
	const lastName = auth.user.lastName || '';
	
	return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
};

export default useAuth;